import { forwardRef, createElement } from 'react';

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2 = /*#__PURE__*/createElement("path", {
  d: "M460.878 492.991H51.122c-20.603 0-37.364-16.76-37.364-37.362V135.415c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v320.213c0 3.745 3.048 6.791 6.793 6.791h409.756c3.745 0 6.793-3.046 6.793-6.791V257.711c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v197.918c.002 20.603-16.759 37.362-37.362 37.362z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/createElement("path", {
  d: "M496.715 164.731V82.607c0-12.193-9.885-22.077-22.078-22.077H37.364c-12.193-.002-22.078 9.884-22.078 22.077v82.126h481.429v-.002z",
  fill: "#DAE8E8"
});

var _ref4 = /*#__PURE__*/createElement("path", {
  d: "M496.715 180.018H15.285C6.843 180.018 0 173.173 0 164.733V82.607c0-20.603 16.76-37.362 37.364-37.362h437.272c20.604 0 37.364 16.76 37.364 37.362v82.126c0 8.44-6.843 15.285-15.285 15.285zM30.571 149.447h450.858v-66.84c0-3.745-3.048-6.79-6.793-6.79H37.364c-3.745 0-6.793 3.045-6.793 6.79v66.84z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/createElement("path", {
  d: "M76.774 104.099c-8.442 0-15.285-6.845-15.285-15.285v-54.52c0-8.441 6.843-15.285 15.285-15.285S92.06 25.854 92.06 34.294v54.519c0 8.44-6.844 15.286-15.286 15.286zM166.387 104.099c-8.442 0-15.285-6.845-15.285-15.285v-54.52c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v54.519c0 8.44-6.843 15.286-15.285 15.286zM345.613 104.099c-8.442 0-15.285-6.845-15.285-15.285v-54.52c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v54.519c.001 8.44-6.843 15.286-15.285 15.286zM255.999 104.099c-8.442 0-15.285-6.845-15.285-15.285v-54.52c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v54.519c.001 8.44-6.843 15.286-15.285 15.286zM435.226 104.099c-8.442 0-15.285-6.845-15.285-15.285v-54.52c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v54.519c0 8.44-6.843 15.286-15.285 15.286zM254.162 359.974a15.286 15.286 0 01-10.808-4.477l-47.382-47.382c-5.969-5.969-5.969-15.648 0-21.618 5.969-5.967 15.648-5.966 21.617 0l36.572 36.574 69.637-69.637c5.969-5.967 15.648-5.967 21.618 0 5.969 5.969 5.969 15.648 0 21.618l-80.446 80.446a15.287 15.287 0 01-10.808 4.476z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/createElement("path", {
  d: "M360.672 416.568H151.328c-8.442 0-15.285-6.845-15.285-15.285V237.839c0-8.441 6.843-15.285 15.285-15.285h94.991c8.442 0 15.285 6.845 15.285 15.285 0 8.441-6.843 15.285-15.285 15.285h-79.706v132.875h178.774V320.57c0-8.441 6.843-15.285 15.285-15.285s15.285 6.845 15.285 15.285v80.715c.001 8.44-6.842 15.283-15.285 15.283z",
  fill: "currentColor"
});

function SvgCalendar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar1);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=calendar-1.svg.js.map
